<template>
  <div id="companies">
    <loader v-if="this.loading" ref="Loader"></loader>
    <div v-if="this.loading === false" class="grid-container-companies">
      <div
          v-for="company in this.companies"
          v-bind:key="company.id"
          class="company-container box"
      >
        <div class="companies-title">
          <font-awesome-icon
              v-if="company.state.favorite === 1"
              class="state-icon-companies"
              icon="heart"
          />
          <font-awesome-icon
              v-if="company.state.exact === 1"
              class="state-icon-companies"
              icon="briefcase"
          />
          <font-awesome-icon
              v-if="company.state.urgent === 1"
              class="state-icon-companies"
              icon="exclamation"
          />
          <router-link
              :to="{ path: '/company/' + company.id }"
              class="state-icon-companies"
          >
            <label class="companies-company-name">{{ company.name }}</label>
          </router-link>
        </div>
        <div class="companies-company-branche">
          {{ company.branche }}
        </div>
        <PolarityGraph
            class="polarity-graph"
            v-bind:company="company"
        ></PolarityGraph>
        <div class="company-footer"></div>
      </div>
    </div>
    <Pagination
        v-show="!this.loading && this.companies.length > 0"
        :pagination="this.pagination"
    ></Pagination>
    <NoResultsFound
        v-if="this.loading === false && this.companies.length === 0"
    ></NoResultsFound>
  </div>
</template>

<script>
import PolarityGraph from "@/components/PolarityGraph.vue";
import Pagination from "@/components/Pagination.vue";
import Loader from "@/components/Loader.vue";
import NoResultsFound from "@/components/NoResultsFound.vue";
import {central_api_domain} from "@/constants/endpoints";

export default {
  name: "Companies",
  props: {
    url: null,
    menuItem: null,
  },
  components: {
    PolarityGraph,
    Pagination,
    Loader,
    NoResultsFound,
  },
  data() {
    return {
      name: "Companies",
      companies: null,
      pagination: null,
      loading: true,
      centralAPIDomain: central_api_domain,
      MenuItem: this.menuItem,
    };
  },
  methods: {
    loadCompanies() {
      this.loading = true;

      let organisationsFilterString = localStorage.getItem('organisationsFilter');
      let organisationsFilter = JSON.parse(organisationsFilterString);

      let url = this.centralAPIDomain + "organisations/filter/object";

      if (organisationsFilter === null) {
        organisationsFilter = this.getDefaultOrganisationsFilter();
      }

      let organisationsPage = null;

      if(this.$route.fullPath.includes('exact')){
        organisationsFilter['exact'] = 1;
        organisationsPage = localStorage.getItem('exactPage');
      }
      else if(this.$route.fullPath.includes('favorite')){
        organisationsFilter['favorite'] = 1;
        organisationsPage = localStorage.getItem('favoritesPage');
      } else {
        organisationsPage = localStorage.getItem('organisationsPage');
      }

      let page = 1;

      if (organisationsPage !== undefined && organisationsPage !== '' && organisationsPage !== null) {
        page = organisationsPage;
      }

      url = url + "?filter=" + JSON.stringify(organisationsFilter) + '&page=' + page;

      fetch(
          url
      )
          .then((res) => res.json())
          .then((result) => {
            this.loading = false;
            let json = JSON.stringify(result);
            let object = JSON.parse(json);
            this.setData(object)
          });
    },
    setData(object) {
      this.companies = object.companiesPageModels;
      this.pagination = object.pagination;
    },
    notRelevant(company) {
      const url = this.centralAPIDomain + "organisations";

      let fetchData = {
        method: "PUT",
        body: JSON.stringify(company),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      fetch(url, fetchData).then((res) => res.json());
    },
    getName() {
      return this.name;
    },
    getDefaultOrganisationsFilter() {
      let filter = {};
      filter["search"] = null;
      filter["min_reviews"] = null;
      filter["branches"] = null;
      return filter;
    }
  },
  mounted() {
    this.$parent.setCurrentPage(this);
  },
};
</script>
